/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Nameplaceholder1Inputs */

const zh_course_nameplaceholder1 = /** @type {(inputs: Course_Nameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：高等数学（上）`)
};

const en_course_nameplaceholder1 = /** @type {(inputs: Course_Nameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Introduction to Calculus`)
};

const es_course_nameplaceholder1 = /** @type {(inputs: Course_Nameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ej: Introducción al Cálculo`)
};

/**
* | output |
* | --- |
* | "e.g. Introduction to Calculus" |
*
* @param {Course_Nameplaceholder1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_nameplaceholder1 = /** @type {((inputs?: Course_Nameplaceholder1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Nameplaceholder1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_nameplaceholder1(inputs)
	if (locale === "en") return en_course_nameplaceholder1(inputs)
	return es_course_nameplaceholder1(inputs)
});
export { course_nameplaceholder1 as "course_namePlaceholder" }